export const IPTOS = `InfiNFT Royale – Terms of Service for IP Providers (NFT Holders)
Effective Date: 06/01/2025

 Operated by: Cuti App LLC, a Georgia Limited Liability Company

1. Overview
These Terms of Service ("Terms") apply to individuals who own NFTs and submit them for use as IP ("IP Providers") in the InfiNFT Royale game. By submitting your NFT and agreeing to participate, you acknowledge and accept these Terms.

2. Eligibility
You must be the legal holder of the NFT you are submitting for use in InfiNFT Royale.

By participating, you confirm that you are at least 18 years old and legally capable of entering into a binding agreement.



3. Rights & IP Submission
By submitting your NFT, you grant Cuti App LLC a non-exclusive, worldwide, royalty-bearing license to use the artwork and related traits from your NFT for the purposes of:

- In-game representation as a character card

- Marketing, promotion, and platform content

You retain ownership of your NFT and IP but grant us rights for adaptation and use within the InfiNFT Royale ecosystem.

You acknowledge that your submission may be modified for gameplay balance, visual consistency, and game design.



4. Royalties & Payouts
If your NFT is featured in card packs or sold individually as a character card:

- 25%-50% of revenue generated from card packs and individual card sales is allocated to you as the IP Provider (card pack percentages are dependent on how many NFT owner’s cards are in said card pack)

- 5-10% goes to the original NFT collection

- 40% goes to Cuti App LLC for platform development and operations

Payments are processed automatically via Stripe to your linked payout method.

You are responsible for any applicable taxes and compliance based on your jurisdiction. Completion of KYC through (Stripe) is required.



5. Representations & Warranties
You warrant that you have the right to submit the NFT and that doing so does not infringe on any third-party rights.

If you submit NFTs from a collection that restricts commercial use and you do not have proper authorization, your privileges may be revoked and legal responsibility lies with you.



6. Account & Termination
Your privileges as an IP Provider may include access to dashboards, character stats, and performance tracking.

Cuti App LLC reserves the right to remove your NFT, revoke privileges, or terminate your participation at any time for breach of terms or platform misuse.



7. Limitation of Liability
Cuti App LLC shall not be held liable for indirect, incidental, or consequential damages.

We disclaim liability in cases where unauthorized NFT submissions result in takedown or loss of earnings.



8. Dispute Resolution
All disputes shall be resolved by binding arbitration under the laws of the State of Georgia, USA.



9. Modifications
We may update these Terms from time to time. You will be notified of material changes via the platform or email.

By submitting your NFT and participating in InfiNFT Royale, you agree to be bound by these Terms.

— The InfiNFT Royale Team`;

export const CTOS = `InfiNFT Royale – Terms of Service for NFT Collection Account
Effective Date: 06/01/2025 

Operated by: Cuti App LLC, a Georgia Limited Liability Company

1. Overview
These Terms of Service ("Terms") govern the use of InfiNFT Royale’s platform by NFT collections ("Collections") who sign up for a Collection Account. These accounts grant special privileges including access to revenue generated through in-game sales of content derived from their submitted intellectual property ("IP").

By creating a Collection Account, you agree to be bound by these Terms.

2. Eligibility & Verification
- You must be the rightful representative of the NFT collection or have permission from the original creators or project owners.

- All Collection Accounts are subject to manual approval by the InfiNFT Royale team.

- You must complete KYC verification through our payment processor (Stripe) to collect revenue.



3. Rights and Responsibilities
- By submitting artwork or NFT content, you represent and warrant that you own the commercial rights or have obtained necessary permission to use the IP in a commercial context.

- Cuti App LLC disclaims any responsibility for IP violations that arise from false or inaccurate representations made by you.

- Breach of these terms, including IP misrepresentation, may result in revocation of account privileges and termination of your collection’s inclusion in the platform.



4. Revenue Share & Payouts
Revenue from the sale of in-game digital assets is shared as follows:

- 5-10% to the NFT collection (you)

- 25-50% to individual holders of featured NFTs(card pack percentages are dependent on how many NFT owner’s cards are in said card pack))

- 40% to Cuti App LLC (the platform operator)

Payouts will be handled automatically via Stripe to your linked wallet/account.

You are responsible for all tax obligations. U.S. and international tax forms (e.g., W-9, W-8BEN) may be required.




5. Privileges & Termination
Collection Accounts may receive access to dashboards, analytics, and marketing exposure.

These privileges may be revoked at any time if you breach these Terms or violate platform policies.

Cuti App LLC reserves the right to remove any collection or IP from the game for any reason, especially in cases of legal risk, misconduct, or misuse.



6. Limitation of Liability
Cuti App LLC shall not be liable for indirect, incidental, or consequential damages.

We are not responsible for loss of revenue due to downtime, bugs, or third-party service failures (including Stripe).



7. Dispute Resolution
Any disputes arising under these Terms shall be resolved through binding arbitration under the laws of the State of Georgia, United States.



8. Modifications
We reserve the right to modify these Terms at any time. Changes will be communicated via email or platform notification.

By continuing to use your Collection Account, you confirm your acceptance of these Terms.

— The InfiNFT Royale Team
`;
